import { render, staticRenderFns } from "./tabs_course.vue?vue&type=template&id=6a419ec0"
import script from "./tabs_course.vue?vue&type=script&lang=ts"
export * from "./tabs_course.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports